module.exports = __webpack_public_path__ + "img/BGMain2.1cbc090f.jpg";